module.exports = __webpack_public_path__ + "static/media/ClearUp.1baad42f.pdf";